export interface ServingParticipant {
  id: string;
  shortName: string;
  color: string;
  logoUrl?: string | null;
  players?: { id: string; name: string }[];
}

export interface ServingInfo {
  servingTeam: ServingParticipant | null;
  serverName: string | null;
}

/**
 * Single source of truth for resolving the current serving team and server name.
 * Used by both the Live Match Card (PublicTournamentCentre) and the
 * detailed Scorecard (PublicLiveScoreboard) so they always display
 * the same serving state.
 *
 * Data source: current_serving_team_id and current_server_id columns
 * on the matches table, written by updateMatchServingTeam().
 */
export function resolveServingInfo(
  currentServingTeamId: string | null | undefined,
  currentServerId: string | null | undefined,
  teamA: ServingParticipant | null,
  teamB: ServingParticipant | null,
): ServingInfo {
  const servingTeam = currentServingTeamId
    ? currentServingTeamId === teamA?.id
      ? teamA
      : currentServingTeamId === teamB?.id
        ? teamB
        : null
    : null;

  const serverName = (servingTeam?.players && currentServerId)
    ? (servingTeam.players.find(p => p.id === currentServerId)?.name ?? null)
    : null;

  return { servingTeam, serverName };
}
